import { AppBar, Box, Button, IconButton, Modal, Toolbar, Typography } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from "react";
import { LoginView } from "./LoginView";

export const Header = (props: {
  handleUpdateLocation: (name: string, id: number) => void,
  locName: string
}) => {
  const {handleUpdateLocation, locName} = props;
  const [openLogin, setOpenLogin] = useState<boolean>(false);
  const [location_name, setLocation_name] = useState<string>(locName)
  const handleCancel = () => {
    setOpenLogin(false);
  }

  const handleOpenLogin = () => {
    setOpenLogin(true);
  }

  const handleSetLocation = (result: {location: string, location_id: number}) => {
    handleUpdateLocation(result.location, result.location_id);
    setLocation_name(result.location);
  }
    return <>
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" elevation={0}>
        <Toolbar sx={{
          background: "#FFFFF9"
        }}>
          <IconButton
            size="large"
            edge="start"
            color="secondary"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: "#000000" }}>
            Robot Admin Dashboard
          </Typography>
          <Button sx={{color: "#000000"}} onClick={handleOpenLogin}>
            {location_name === "L1Charge" ? "VES" : location_name === "nurse_station_L14" ? "Ward 14" : location_name}
          </Button>
        </Toolbar>
      </AppBar>
    </Box>

    <Modal open={openLogin} disableEnforceFocus={false}>
      <LoginView handleCancel={handleCancel} updateLocation={handleSetLocation} />
    </Modal>
    
    </>
}